import { pickBy } from 'lodash';

const NODE_ENV = process.env.NODE_ENV;
export const IS_LOCAL = NODE_ENV === 'development' || NODE_ENV === 'test';
export const IS_PROD = !IS_LOCAL;

export const API_HOST = IS_LOCAL ? process.env.REACT_APP_LOCAL_API_HOST : `${window.location.protocol}//${window.location.host}/admin/api`;

export const pickDevParams = pickBy({ });

export const defaultNotificationOptions = {
  title: 'Error',
  message: null,
  type: 'danger',
  insert: 'top',
  container: 'bottom-right',
  animationIn: ['animate__animated', 'animate__fadeIn'],
  animationOut: ['animate__animated', 'animate__fadeOut'],
  dismiss: {
    duration: 3000,
  },
}

export const UI_NAME = 'p-ui'
